exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swiper[data-v-6753e4e2] {\n  border-radius: 0.8rem;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n.swiper-pagination.swiper-pagination-progressbar[data-v-6753e4e2] {\n  width: 94% !important;\n  margin-left: 3% !important;\n  bottom: 1px !important;\n  border-radius: 20px !important;\n  top: initial;\n}", ""]);

// exports
